import React, { useEffect, useRef, useState } from "react";
import { useAutoAnimate } from "@formkit/auto-animate/react";
import "../../assets/styles/local/AddScreenLabels.css";
import { Tooltip, Progress, FloatButton } from "antd";
import { DeleteOutlined, EditOutlined, UndoOutlined } from "@ant-design/icons";
import Header from "../../layouts/Header";
import ReactPaginate from "react-paginate";
import { useHistory, useLocation, Link } from "react-router-dom";
import {
  FetchCompany,
  FetchScreenname,
  createTranslation,
  fetchLanguages,
  fetchRoleModule,
  fetchTranslationData,
  updateTranslationData,
  AddTranslationData,
} from "../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";
import trans_icon from "../../assets/icons/icon_set.svg";
import contacticons from "../../assets/icons/Group 3321.svg";
import Xicon from "../../assets/icons/Xicon.svg";
import XiconCircle from "../../assets/icons/x-circle.svg";
import DownArrowOption from "../../assets/icons/DownArrowOption.svg";
import { fetchScreenTranslations } from "../../utils/helpers/translations";
import RouteLeavingGuard from "../../components/Common/RouteLeavingGuard";

const AddScreenLabels = () => {
  const dispatch = useDispatch();
  const [Ankit] = useAutoAnimate();
  const history = useHistory();
  const location = useLocation();
  const path = location.pathname;

  const companyId = window.localStorage.getItem("companyid");
  const userId = window.localStorage.getItem("userid");
  const roleid = window.localStorage.getItem("roleid");

  const fetchCompanyListRes = useSelector(
    (state) => state.user.FetchCompanyList
  );

  const roleModuleDataRes = useSelector((state) => state.user.roleModuleData);
  const fetchScreenListRes = useSelector((state) => state.user.FetchScreenList);
  const addTranslationDataRes = useSelector(
    (state) => state.user.addTranslationDataRes
  );

  const [query, setQuery] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyID, setCompanyID] = useState("");

  const [moduleData, setModuleData] = useState([]);
  const [selectedModule, setSelectedModule] = useState("");
  const [selectedModuleID, setSelectedModuleID] = useState("");
  const [moduleDataOpen, setModuleDataOpen] = useState(false);
  const [arrowOptionsRotate, setArrowOptionsRotate] = useState(false);

  const [screenData, setScreenData] = useState([]);
  const [selectedScreen, setSelectedScreen] = useState("");
  const [selectedScreenID, setSelectedScreenID] = useState("");
  const [screenDataOpen, setScreenDataOpen] = useState(false);
  const [arrowOptionsRotate2, setArrowOptionsRotate2] = useState(false);

  const [screenTranslations, setScreenTranslations] = useState({});
  const t = (key) => screenTranslations?.[key] || "";

  useEffect(() => {
    dispatch(FetchCompany());
    dispatch(fetchLanguages());
    dispatch(fetchRoleModule(roleid));

    fetchScreenTranslations("Translation").then((res) => {
      setScreenTranslations(res);
    });
  }, []);

  useEffect(() => {
    if (fetchCompanyListRes?.data?.status === true) {
      console.log("asc fetchCompany", fetchCompanyListRes);
      setCompanyName(fetchCompanyListRes?.data?.data[0]?.companyname);
      setCompanyID(fetchCompanyListRes?.data[0]?.companyid);
    }
  }, [fetchCompanyListRes]);

  useEffect(() => {
    if (roleModuleDataRes?.status === true) {
      setModuleData(roleModuleDataRes?.data);
    }
  }, [roleModuleDataRes]);

  useEffect(() => {
    if (fetchScreenListRes?.data?.status === true) {
      setScreenData(fetchScreenListRes?.data?.data);
    }
  }, [fetchScreenListRes]);

  useEffect(() => {
    if (addTranslationDataRes?.status === true) {
      setTimeout(() => {
        window.location.reload();
      }, 500);
    }
  }, [addTranslationDataRes]);

  const [personalTaskData, setPersonalTaskData] = useState([
    {
      firstName: "",
      middleName: "",
      lastName: "",
    },
  ]);

  const handleOnChange2 = (index, field, value) => {
    // here value = e.target.value
    // and field = like => list[index]["supplier"]

    let list = [...personalTaskData];
    list[index][field] = value;
    let firstName_length = list[index]["firstName"].length;
    let middleName_length = list[index]["middleName"].length;
    let LastName_length = list[index]["lastName"].length;

    if (firstName_length > 0 && middleName_length > 0 && LastName_length > 0) {
      let obj = list[index + 1];
      if (!obj) {
        list.push({
          firstName: "",
          middleName: "",
          lastName: "",
        });
      }
    }
    setPersonalTaskData([...list]);
  };

  const handleOnChange = (index, field, value) => {
    // let list = [...personalTaskData];
    // list[index][field] = value;

    // const { firstName, middleName, lastName } = list[index];

    // if (firstName && middleName && lastName && !list[index + 1]) {
    //   list.push({ firstName: "", middleName: "", lastName: "" });
    // }
    // setPersonalTaskData(list);

    let list = [...personalTaskData];
    list[index][field] = value;

    const { firstName, middleName } = list[index];

    if (firstName && middleName && !list[index + 1]) {
      list.push({ firstName: "", middleName: "" });
    }
    setPersonalTaskData(list);
  };

  const handleAddTranslation = () => {
    console.log("asc payload personalTaskData", personalTaskData);
    const data = {
      screenid: selectedScreenID,
      labels: personalTaskData
        .filter((x) => x.firstName?.trim() && x.middleName?.trim())
        .map((item) => ({
          languageid: "08dac62b-6a79-47cf-870a-ada9f72918a1",
          fieldname: item.firstName,
          translation: item.middleName,
        })),
    };

    dispatch(AddTranslationData(data));
  };

  return (
    <div className="ps-3">
      <div>
        <Header setQuery={setQuery} reRenderTranslate={"reRenderTranslate"} />
        <div style={{ paddingRight: "10px" }}></div>
      </div>

      <div className="d-flex flex-wrap gap-3 pt-2 justify-content-between align-items-center pe-4">
        <p className="mb-0 p-3 setting-title">Add Translations</p>
        <div className="d-flex gap-3">
          <button
            className="mb-0 ms-md-auto cancelBtn ascButton"
            // onClick={() => {
            //   if (typeInScreen !== "") {
            //     setCancelPopupShow(true);
            //   } else {
            //     history.goBack();
            //     // history.push("/InvoiceAllList");
            //   }
            // }}

            onClick={() => {
              // history.goBack();
              history.push("/settings");
            }}
          >
            Cancel
          </button>

          <button
            className="mb-0 makeInvoBtn ascButton"
            // onClick={
            //   billingInformationID ? handleUpdate_Billing : handleAdd_Billing
            // }

            onClick={handleAddTranslation}
          >
            Add
          </button>
        </div>
      </div>

      <div className="p-3 row gap-4 pt-5 pt-md-3">
        <div className="col-md-4 col-lg-4 col-xl-3 col-xxl-3">
          <p className="drp_font">{t("Tasks Messages")}</p>
          <p className="drp_font_label">{companyName}</p>
        </div>

        {/* module box start */}
        <div className="col-md-4 col-lg-4 col-xl-3 col-xxl-3 position-relative">
          <p className="drp_font">{t("Load more...")}</p>
          <div className="d-flex gap-3 align-items-center">
            <p
              className="mb- pointer arrowsDiv p-0"
              style={{
                fontSize: "14px",
                fontWeight: "500",
                color: "black",
                opacity: "65%",
                border: "none",
                minWidth: "80%",
              }}
              onClick={() => {
                setModuleDataOpen(!moduleDataOpen);
                setArrowOptionsRotate(!arrowOptionsRotate);
              }}
            >
              {selectedModule || "select a module"}
            </p>

            {/* {selectedModule ? (
              <img
                src={Xicon}
                className="xicon pointer"
                style={{ width: "8px" }}
                alt=""
                onClick={() => {
                  setSelectedModule("");
                  setSelectedModuleID("");
                  // setChangeComp("asc");
                }}
              />
            ) : (
              <img
                src={DownArrowOption}
                className={arrowOptionsRotate ? "upArrow" : "downArrow"}
                style={{ width: "10px" }}
                alt=""
                onClick={() => {
                  setModuleDataOpen(true);
                  setArrowOptionsRotate(true);
                }}
              />
            )} */}
          </div>

          {moduleDataOpen && (
            <div
              className="userDataSelectBox"
              style={{ position: "absolute", right: "5px" }}
            >
              <div className="userDataOptionDiv">
                {moduleData.map((module, moduleIndex) => {
                  return (
                    <div
                      className={
                        selectedModuleID === module.moduleid
                          ? "selectedData"
                          : "userDataOption"
                      }
                      onClick={() => {
                        setSelectedModule(module.modulename);
                        setSelectedModuleID(module.moduleid);
                        setArrowOptionsRotate(false);
                        dispatch(FetchScreenname(module?.moduleid));
                        setModuleDataOpen(false);
                      }}
                    >
                      <p className="mb-1">{module.modulename}</p>
                    </div>
                  );
                })}

                {moduleData.length === 0 && (
                  <p className="noDataDisplay mb-0 p-2">No data to display!</p>
                )}
              </div>
            </div>
          )}
        </div>
        {/* module box end */}

        {/* screen box start */}
        <div className="col-md-4 col-lg-4 col-xl-3 col-xxl-3 position-relative">
          <p className="drp_font">{t("Collaborate")}</p>
          <p
            className="mb- pointer arrowsDiv p-0"
            style={{
              fontSize: "14px",
              fontWeight: "500",
              color: "black",
              opacity: "65%",
              border: "none",
            }}
            onClick={() => {
              setScreenDataOpen(!screenDataOpen);
            }}
          >
            {selectedScreen || "select a screen"}
          </p>

          {screenDataOpen && (
            <div
              className="userDataSelectBox"
              style={{ position: "absolute", right: "5px" }}
            >
              <div className="userDataOptionDiv">
                {screenData.map((screen, screenIndex) => {
                  return (
                    <div
                      className={
                        selectedScreenID === screen.screenid
                          ? "selectedData"
                          : "userDataOption"
                      }
                      onClick={() => {
                        setSelectedScreen(screen.screenname);
                        setSelectedScreenID(screen.screenid);
                        // dispatch(FetchScreenname(screen?.screenid));
                        setScreenDataOpen(false);
                      }}
                    >
                      <p className="mb-1">{screen.screenname}</p>
                    </div>
                  );
                })}

                {screenData.length === 0 && (
                  <p className="noDataDisplay mb-0 p-2">No data to display!</p>
                )}
              </div>
            </div>
          )}
        </div>
        {/* screen box end */}
      </div>

      {/* Add labels start from below */}
      <div ref={Ankit}>
        {personalTaskData.map((item, index) => {
          return (
            <div
              className="row gap-3 align-items-center mb-3"
              key={index}
              style={{ marginBottom: "10px" }}
            >
              <div className="col-12 col-md-4">
                <input
                  type="text"
                  placeholder="Add key label"
                  className="ms-2 p-2 transLabelInput"
                  value={item.firstName}
                  onChange={(e) =>
                    handleOnChange(index, "firstName", e.target.value)
                  }
                />
              </div>

              <div className="col-12 col-md-4">
                <input
                  type="text"
                  placeholder="Add EN Translation"
                  className="ms-2 p-2 transLabelInput"
                  value={item.middleName}
                  onChange={(e) =>
                    handleOnChange(index, "middleName", e.target.value)
                  }
                />
              </div>

              {/* <div className="col-12 col-md-3">
                <input
                  type="text"
                  placeholder="Add NL Translation"
                  className="ms-2 p-2 transLabelInput"
                  value={item.lastName}
                  onChange={(e) =>
                    handleOnChange(index, "lastName", e.target.value)
                  }
                />
              </div> */}

              <div className="col-12 col-md-1">
                <div className="d-flex gap-3 pointer">
                  {personalTaskData.length !== 1 && (
                    <>
                      <Tooltip title="Delete" color={"red"}>
                        <p
                          className="mb-0 labelDltIcon ms-auto"
                          onClick={() => {
                            let data = [...personalTaskData];
                            data.splice(index, 1);
                            setPersonalTaskData(data);
                          }}
                        >
                          {/* x */}
                          <DeleteOutlined />
                        </p>
                      </Tooltip>

                      <Tooltip title="Undo" color={""}>
                        <p
                          className="mb-0 undoIcon"
                          onClick={() => {
                            let data = [...personalTaskData];
                            data[index] = {
                              lastName: "",
                              middleName: "",
                              firstName: "",
                            }; // Set empty values
                            setPersonalTaskData(data);
                          }}
                        >
                          <UndoOutlined />
                        </p>
                      </Tooltip>
                    </>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AddScreenLabels;
